import { render, staticRenderFns } from "./documents-form.vue?vue&type=template&id=cf08e02e&"
import script from "./documents-form.vue?vue&type=script&lang=ts&"
export * from "./documents-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports